<template>
  <PageContainer title="Alunos Faturados">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box v-else class="alunos-container" space="medium">
      <form @submit.prevent="handleSubmit">
        <div class="radio">
          <span>Selecione o critério de consulta</span>

          <RadioButtons :options="consultOptions" name="consult" :modelValue="consult"
            @update:modelValue="$event => this.consult = $event" />
        </div>

        <div class="inputs">
          <div class="inputs-row">
            <Select class="input-full" :options="schemaOptions" legend="Autoescola" placeholder="Selecione"
              :modelValue="schema" @update:modelValue="$event => (this.schema = $event)" />

            <template v-if="consult === 'period'">
              <Period class="input-full" legend="Data" :firstModelValue="initialDate" :secondModelValue="finalDate"
                @update:firstModelValue="$event => (this.initialDate = $event)"
                @update:secondModelValue="$event => (this.finalDate = $event)" :disabled="loading" />
            </template>

            <template v-if="consult === 'student'">
              <Input class="input-full" :modelValue="aluno" @update:modelValue="$event => (this.aluno = $event)"
                legend="Aluno" placeholder="Nome do aluno(a)" :disabled="loading" />
            </template>

            <template v-if="consult === 'cpf'">
              <Input class="input-full" mask="###.###.###-##" :modelValue="cpf"
                @update:modelValue="$event => (this.cpf = $event)" legend="CPF" placeholder="CPF" :disabled="loading" />
            </template>

            <template v-if="consult === 'renach'">
              <Input class="input-full" :modelValue="renach" @update:modelValue="$event => (this.renach = $event)"
                legend="Renach" placeholder="Renach" :disabled="loading" />
            </template>
          </div>

          <div class="inputs-row">

          </div>

          <div class="buttons">
            <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
              :disabled="loading">
              <CloseCircleOutline :size="18" />
            </Button>

            <Button type="submit" text="Consultar" color="primary" :disabled="loading">
              <Magnify :size="18" />
            </Button>
          </div>
        </div>
      </form>

      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <div v-else-if="!loading && alunos.length" class="table-container">
        <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
          @page-changed="fetchAlunos" />

        <Table :headers="['Nome', 'CPF', 'Renach', 'Ações']">
          <tr v-for="aluno in alunos" :key="aluno.id_aluno">
            <td>{{ aluno.nome }}</td>
            <td>{{ aluno.cpf }}</td>
            <td>{{ aluno.renach }}</td>
            <td>
              <div class="actions">
                <div>
                  <IconButton @handle:click="() => openInfoFaturaModal(aluno)" color="secondary"
                    title="Visualizar Faturas" :disabled="loading">
                    <FileOutline :size="19" />
                  </IconButton>
                </div>
              </div>
            </td>
          </tr>
        </Table>
      </div>
    </Box>

    <InfoFaturaModal ref="infoFaturaModal" />
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import LoadingSpinner from 'core/LoadingSpinner'
import Box from 'core/Box'
import RadioButtons from 'core/RadioButtons'
import Select from 'core/Select'
import Input from 'core/Input'
import Period from 'core/Period'
import Button from 'core/Button'
import Table from 'core/Table'
import Paginate from 'core/Paginate'
import IconButton from 'core/IconButton'
import FileOutline from 'icons/FileOutline'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'
import InfoFaturaModal from './modal/InfoFaturaModal'

export default {
  name: 'AlunosGratuidade',
  components: {
    PageContainer,
    LoadingSpinner,
    Box,
    RadioButtons,
    Table,
    Paginate,
    IconButton,
    Select,
    Input,
    Period,
    Button,

    FileOutline,
    CloseCircleOutline,
    Magnify,

    InfoFaturaModal,
  },
  data() {
    return {
      consult: 'period',
      schema: '',
      initialDate: '',
      finalDate: '',
      aluno: '',
      cpf: '',
      renach: '',
      consultOptions: [
        { value: "period", label: "Período" },
        { value: "student", label: "Nome do Aluno" },
        { value: "cpf", label: "CPF" },
        { value: "renach", label: "Renach" },
      ],
      paginationData: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      schemaOptions: [],
      alunos: [],
      loaded: false,
      loading: false,
    }
  },
  async created() {
    await this.fetchCfcs()

    this.loaded = true
  },
  methods: {
    async fetchCfcs() {
      try {
        const response = await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)

        this.schemaOptions = response.body.dados.map((cfc) => {
          const sindicatoSuffix = cfc.sindicato ? ' - Sindicato' : ''
          return {
            value: cfc.tenant_schema,
            text: `${cfc.nome_fantasia}${sindicatoSuffix}`,
          }
        })
      } catch (error) {
        this.$toasted.show('Erro!' + (error.body && error.body.mensagem ? error.body.mensagem : ''), {
          position: 'top-right',
        })
      }
    },
    validateInputs() {
      if (!this.schema) {
        this.$toasted.show('Selecione uma autoescola!', {
          position: 'top-right',
        })

        return false
      }

      switch (this.consult) {
        case 'period':
          if (!this.initialDate && !this.finalDate) {
            this.$toasted.show('Preencha o todas as datas.', {
              position: 'top-right',
            })
            return false
          }

          if (this.initialDate && this.finalDate) {
            const initial = new Date(this.initialDate)
            const final = new Date(this.finalDate)

            if (initial > final) {
              this.$toasted.show('A data inicial deve ser menor ou igual à data final.', {
                position: 'top-right',
              })
              return false
            }
          }

          break
        case 'student':
          if (!this.aluno) {
            this.$toasted.show('Preencha o campo "Aluno".', {
              position: 'top-right',
            })
            return false
          }

          break
        case 'cpf':
          if (!this.cpf) {
            this.$toasted.show('Preencha o campo "CPF".', {
              position: 'top-right',
            })
            return false
          }

          break
        case 'renach':
          if (!this.renach) {
            this.$toasted.show('Preencha o campo "Renach".', {
              position: 'top-right',
            })
            return false
          }

          break
      }

      return true
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        await this.fetchAlunos()
      }
    },
    async fetchAlunos(page = 1) {
      this.loading = true

      const params = {
        page,
      }

      const data = {
        schema: this.schema,
      }

      if (this.initialDate && this.finalDate) {
        data.dataIni = this.initialDate
        data.dataFim = this.finalDate
      }
      if (this.aluno) data.nome = this.aluno
      if (this.cpf) data.cpf = this.cpf
      if (this.renach) data.renach = this.renach

      await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/alunos/consultar/alunos`, data, {
        params,
      })
        .then(res => {
          const result = res.body.alunos

          if (result.data < 1) {
            this.$toasted.show('Sem resultados', {
              position: 'top-right',
            })
          }

          this.alunos = result.data

          this.paginationData = {
            currentPage: result.current_page,
            lastPage: result.last_page,
            total: result.total,
          }
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInputs() {
      this.consult = 'period'
      this.schema = ''
      this.initialDate = ''
      this.finalDate = ''
      this.aluno = ''
      this.cpf = ''
      this.renach = ''
    },
    openInfoFaturaModal(aluno) {
      this.$refs.infoFaturaModal.open(aluno, this.schema)
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.alunos-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .radio {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      span {
        font-size: 1rem;
        font-weight: 600;
        line-height: 21.82px;
        color: #606264;
      }
    }

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .pagination-container {
      align-self: flex-end;
    }

    .table-container {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .infos {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 1.5rem;
      }

      .table-header {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;

        .table-legend {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 0.625rem;

          >div {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }
        }
      }

      .actions {
        max-width: 8rem;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        row-gap: 0.5rem;

        div {
          padding: 0 0.5rem;
          display: flex;
          justify-content: center;

          &:not(:last-child) {
            border-right: 1px solid #ECECEC;
          }
        }
      }
    }
  }
}
</style>
